import { render, staticRenderFns } from "./DashboardCreateUpdate.vue?vue&type=template&id=c7ef840c&scoped=true"
import script from "./DashboardCreateUpdate.vue?vue&type=script&lang=js"
export * from "./DashboardCreateUpdate.vue?vue&type=script&lang=js"
import style0 from "./DashboardCreateUpdate.vue?vue&type=style&index=0&id=c7ef840c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ef840c",
  null
  
)

export default component.exports